// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#f0834c"};